import type { ValidateResult } from 'react-hook-form'
import { i18n } from '../i18n'
import { parseDecimal } from '../util/parsers'

const positiveInteger = {
  pattern: {
    value: /^[123456789][\d\s]*$/,
    message: i18n.t('validation.positiveInteger'),
  },
}

const nonNegativeInteger = {
  pattern: {
    value: /^[0123456789][\d\s]*$/,
    message: i18n.t('validation.nonNegativeInteger'),
  },
}

const decimal = {
  pattern: {
    value: /^-?[\d\s]+([.,]\d+)?$/,
    message: i18n.t('validation.decimal'),
  },
}

const notEmpty = {
  validate: (data: unknown[] | undefined | null): ValidateResult =>
    data && data.length > 0 ? true : String(i18n.t('validation.required')),
}

const min = (minValue: number) => (value: string) =>
  parseDecimal(value) >= minValue
    ? true
    : i18n.t('validation.min', { value: minValue })

const max = (maxValue: number) => (value: string) =>
  parseDecimal(value) <= maxValue
    ? true
    : i18n.t('validation.max', { value: maxValue })

export const validators = {
  required: {
    required: { value: true, message: i18n.t('validation.required') },
  },

  notEmpty,

  positiveInteger,

  nonNegativeInteger,

  decimal,

  positiveDecimal: {
    ...decimal,
    validate: {
      min: min(0.001),
    },
  },

  positiveDecimalZero: {
    ...decimal,
    validate: {
      min: min(0),
    },
  },

  efficiency: {
    ...decimal,
    validate: {
      min: min(0.001),
      max: max(1),
    },
  },

  efficiencyZero: {
    ...decimal,
    validate: {
      min: min(0),
      max: max(1),
    },
  },

  cop: {
    ...decimal,
    validate: {
      min: min(1),
      max: max(100),
    },
  },

  eer: {
    ...decimal,
    validate: {
      min: min(1),
      max: max(100),
    },
  },

  maxPower: {
    ...decimal,
    validate: {
      min: min(0),
    },
  },

  area: {
    ...decimal,
    validate: {
      min: min(1),
    },
  },

  copModifier: {
    ...decimal,
    validate: {
      min: min(0),
    },
  },

  temperatureCurveRowCount: {
    ...positiveInteger,
    validate: {
      min: min(2),
      max: max(6),
    },
  },

  percent: {
    ...decimal,
    validate: {
      min: min(0),
      max: max(100),
    },
  },
}
